<template>
    <div class="relative radius-large" v-click-outside="closeActions">
        <button class="btn wider" @click="toggleActions">    
            {{ label }}
            <span class="ml-2" :class="['ico-arrow-' + direction]"></span>
        </button>

        <ul class="floating-menu bottom" v-if="showActions">
            <li v-for="option in options" @click="clickOption(option.fn, option.value)">
                {{ option.label }}
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        props: {
            label: String,
            options: Array
        },
        data: function() {
            return {
                showActions: false,
                direction: 'bottom',
            }
        },
        methods: {
            ...mapActions([
                'openModal',
            ]),
            clickOption: function(fn, value) {
                if (typeof fn === 'function') {
                    fn(value);
                }
            },
            toggleActions: function() {
                this.showActions = !this.showActions;
                this.direction = (this.direction == 'top') ? 'bottom' : 'top';
            },
            closeActions: function() {
                this.showActions = false;
            }
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// DropdownButton.vue?3744205b